/**
 * @file Business days calculation utility
 * @description Counts weekday (Mon-Fri) days between two dates inclusive.
 * Used for auto-calculating estimated effort days from roadmap item date ranges.
 */

/**
 * Count the number of business days (Mon-Fri) between two date strings, inclusive.
 *
 * @param startStr - ISO date string (YYYY-MM-DD) for the start date
 * @param endStr - ISO date string (YYYY-MM-DD) for the end date
 * @returns Number of business days, or 0 if inputs are invalid or end < start
 */
export function countBusinessDays(startStr: string, endStr: string): number {
  if (!startStr || !endStr) {
    return 0;
  }

  const start = new Date(startStr + 'T00:00:00');
  const end = new Date(endStr + 'T00:00:00');

  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return 0;
  }
  if (end < start) {
    return 0;
  }

  let count = 0;
  const current = new Date(start);

  while (current <= end) {
    const day = current.getDay();
    // 0 = Sunday, 6 = Saturday
    if (day !== 0 && day !== 6) {
      count++;
    }
    current.setDate(current.getDate() + 1);
  }

  return count;
}
